import { render, staticRenderFns } from "./SelectWholesaleOrderShipping.vue?vue&type=template&id=7f472f57"
import script from "./SelectWholesaleOrderShipping.vue?vue&type=script&lang=js"
export * from "./SelectWholesaleOrderShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports